import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 10, // 10 minutes 
      gcTime: 1000 * 60 * 30, // 30 minutes 
      refetchOnWindowFocus: false, // Disable refetch when window regains focus
      retry: (failureCount, error) => {
        // Don't retry on 4xx client errors (400, 401, 403, 404, etc.)
        // Check if it's an Axios error with response status
        if (error && typeof error === 'object' && 'response' in error) {
          const axiosError = error as { response?: { status?: number } };
          if (axiosError.response?.status && axiosError.response.status >= 400 && axiosError.response.status < 500) {
            return false;
          }
        }
        // Retry on 5xx server errors or network errors
        return failureCount < 3;
      },
      retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000),
    },
  },
});
